import { Component, Input } from "@angular/core";
import { ControlPanelMenuItem } from "../control-panel-layout/control-panel-menu/control-panel-menu-item.model";
import { HtmlTipComponent } from "../html-tip/html-tip.component";

@Component({
    selector: "kno2-control-panel",
    templateUrl: "./control-panel.component.html",
    styleUrls: ["./control-panel.component.scss"],
    standalone: false
})
export class ControlPanelComponent {
    @Input() public renderAsGrid = false;
    @Input() public sidebarItems: Array<ControlPanelMenuItem>;
    public htmlTipComponent = HtmlTipComponent;

    public get items(): Array<ControlPanelMenuItem> {
        return this.sidebarItems?.filter((i) => !i.disabled);
    }
}
